import { render, staticRenderFns } from "./material-sel-page.vue?vue&type=template&id=4bcc126f&scoped=true"
import script from "./material-sel-page.vue?vue&type=script&lang=js"
export * from "./material-sel-page.vue?vue&type=script&lang=js"
import style0 from "./material-sel-page.vue?vue&type=style&index=0&id=4bcc126f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc126f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bcc126f')) {
      api.createRecord('4bcc126f', component.options)
    } else {
      api.reload('4bcc126f', component.options)
    }
    module.hot.accept("./material-sel-page.vue?vue&type=template&id=4bcc126f&scoped=true", function () {
      api.rerender('4bcc126f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/material-sel-page.vue"
export default component.exports